export default __webpack_public_path__ + "locales/pt/WebPlugins.json?hash=961369771b3a1233377606b6ce04e8d0";